import { render, staticRenderFns } from "./truestatistics.vue?vue&type=template&id=47ff46cc&scoped=true&"
import script from "./truestatistics.vue?vue&type=script&lang=js&"
export * from "./truestatistics.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=47ff46cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ff46cc",
  null
  
)

export default component.exports